import { render, staticRenderFns } from "./RegisterVerifyOTPPanel.vue?vue&type=template&id=497934aa&scoped=true&"
import script from "./RegisterVerifyOTPPanel.vue?vue&type=script&lang=js&"
export * from "./RegisterVerifyOTPPanel.vue?vue&type=script&lang=js&"
import style0 from "./RegisterVerifyOTPPanel.vue?vue&type=style&index=0&id=497934aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497934aa",
  null
  
)

export default component.exports